exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2xpKS{position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;border-radius:4px;width:700px;display:-webkit-box;display:-ms-flexbox;display:flex;padding:25px 25px 35px}._3VfFh{padding:25px 0;width:95%}.UzjYO{min-width:400px;height:auto}.ySG2w{width:90%;max-height:350px;overflow-y:auto}._2vdvi{font-weight:700;margin:0 10px 10px;text-transform:uppercase}._3fr06{font-weight:700;padding:2px 10px}.LMvVJ{padding:10px 20px;font-size:16px}._3ea1a{padding:10px 0}._3pNi2{text-align:left}._276tr{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:end;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:15px;margin-bottom:5px}._2q7a2{line-height:16px}._1SEoY{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px}._1SEoY:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"modal": "_2xpKS",
	"mobileModal": "_3VfFh",
	"desktopRoot": "UzjYO",
	"mobileRoot": "ySG2w",
	"optionTitle": "_2vdvi",
	"optionItemTitle": "_3fr06",
	"mainInfoText": "LMvVJ",
	"mobileMainInfoTex": "_3ea1a",
	"optionSection": "_3pNi2",
	"modalOptions": "_276tr",
	"optionItemText": "_2q7a2",
	"closeBtn": "_1SEoY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Discount/InfoModal/InfoModal.css
// module id = 1929
// module chunks = 18 19 32 36 37